import { Link } from "react-router-dom";
import { MessageCircle, Phone } from "lucide-react";
import { Logo } from "./Logo";
import { PHONE, PHONE_LINK, waLink, WA_DEFAULT_MSG } from "../lib/site";

export const Footer = () => (
  <footer
    data-testid="footer-section"
    className="bg-[#050608] border-t border-white/10 tech-grid-bg"
  >
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-14 grid gap-10 md:grid-cols-3">
      <div>
        <Logo />
        <p className="mt-5 text-sm text-slate-400 leading-relaxed max-w-xs">
          منصة متخصصة في حساسات ضغط الإطارات TPMS في الرياض: بيع وبرمجة وفحص
          واستبدال، مع مساعدتك في اختيار الحساس المتوافق مع سيارتك.
        </p>
        <p data-testid="footer-location-text" className="mt-4 text-xs font-mono text-slate-500">
          الرياض، المملكة العربية السعودية
        </p>
      </div>

      <div>
        <h3 className="font-display font-semibold text-white mb-4 text-base">روابط سريعة</h3>
        <ul className="grid grid-cols-2 gap-x-4 gap-y-2.5 text-sm text-slate-400">
          {[
            ["/sensors", "حساسات الكفرات"],
            ["/programming", "برمجة الحساسات"],
            ["/replacement", "استبدال الحساسات"],
            ["/inspection", "فحص الحساسات"],
            ["/compatibility", "التوافق مع السيارات"],
            ["/about", "من نحن"],
            ["/faq", "الأسئلة الشائعة"],
            ["/contact", "اتصل بنا"],
          ].map(([to, label]) => (
            <li key={to}>
              <Link to={to} className="hover:text-red-400 transition-colors">
                {label}
              </Link>
            </li>
          ))}
        </ul>
      </div>

      <div>
        <h3 className="font-display font-semibold text-white mb-4 text-base">تواصل مباشرة</h3>
        <div className="flex flex-col gap-3">
          <a
            href={waLink(WA_DEFAULT_MSG)}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="footer-whatsapp-link"
            className="inline-flex items-center gap-2.5 text-sm text-slate-300 hover:text-emerald-400 transition-colors"
          >
            <MessageCircle size={17} className="text-emerald-500" />
            واتساب: <span dir="ltr" className="font-mono">{PHONE}</span>
          </a>
          <a
            href={PHONE_LINK}
            data-testid="footer-phone-link"
            className="inline-flex items-center gap-2.5 text-sm text-slate-300 hover:text-red-400 transition-colors"
          >
            <Phone size={17} className="text-red-500" />
            اتصال: <span dir="ltr" className="font-mono">{PHONE}</span>
          </a>
        </div>
        <p className="mt-5 text-xs text-slate-500 leading-relaxed">
          جميع الاستفسارات وطلبات الأسعار تتم عبر واتساب. التوافق يعتمد على
          الموديل وسنة الصنع ونوع النظام.
        </p>
      </div>
    </div>
    <div className="border-t border-white/5 py-5 text-center text-xs text-slate-600">
      حساسات كفرات الرياض — Riyadh Tire Sensors © {new Date().getFullYear()}
    </div>
  </footer>
);
